import { jsx as _jsx } from "react/jsx-runtime";
const ChevronDownIcon = ({ size = '24px', color = 'currentColor', ...attributes }) => {
    return (_jsx("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...attributes, children: _jsx("path", { d: "M4 6L8 10L12 6", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
export default ChevronDownIcon;
//# sourceMappingURL=chevron-down.js.map